import React from 'react';
import PropTypes from 'prop-types';

import { LazyHydrate } from 'nordic/lazy';

import Metatata from '../../../components/Landing/Metadata';
import getComponentConfig from '../../../components/Landing';
import { UI_LANDING_STYLE_PREFIX } from '../../../constants/appConstants';

const Landing = (props) => {
  const { device, landingData, jsDisabled, supportWebP, melidata } = props;

  const { metadata, component_data: components } = landingData;

  const namespace = `${UI_LANDING_STYLE_PREFIX}-ui-components`;

  const showComponent = (name, value) => {
    const { Component, isSsrOnly, isWhenVisible, isWhenIdle } =
      getComponentConfig(name);

    if (Component) {
      return (
        <div className={`${namespace}-component`}>
          <LazyHydrate
            ssrOnly={isSsrOnly}
            whenVisible={isWhenVisible}
            whenIdle={isWhenIdle}
            key={name}
          >
            <Component
              value={value}
              device={device}
              jsDisabled={jsDisabled}
              supportWebP={supportWebP}
              melidata={melidata}
            />
          </LazyHydrate>
        </div>
      );
    }

    return undefined;
  };

  const showComponents = () =>
    components.map(({ name, value }) => showComponent(name, value));

  return (
    <>
      <LazyHydrate ssrOnly>
        <Metatata metadata={metadata} />
      </LazyHydrate>

      {showComponents()}
    </>
  );
};

Landing.propTypes = {
  device: PropTypes.string.isRequired,
  jsDisabled: PropTypes.bool.isRequired,
  supportWebP: PropTypes.bool.isRequired,
  landingData: PropTypes.shape().isRequired,
  melidata: PropTypes.shape({
    user_type: PropTypes.string,
    logged: PropTypes.bool,
    business_unit: PropTypes.string.isRequired,
    page_type: PropTypes.string.isRequired,
    brand: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
};

export default Landing;
